import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGridField } from "../../../../../utils/forms/components/FormGrid";
import * as Yup from "yup";
import _ from "lodash";
import permissionsJson from "../../../../../jsons/permissions.json";
import Form from "../../../../../utils/forms/components/Form";

import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

import { authStoreSelectors } from "../../../store/store";
import { skeletonStoreSelectors } from "../../../../../store";
import { Route } from "../../../../../api/apiTypes";
import Collapse from "../../../../../utils/Collapse/Collapse.component";
import { ROLE_ACTIONS } from "../RolesList/RolesListPage.component";
import { SubsidiaryUtils } from "../../../../../utils/Subsidiary/SubsidiaryUtils";
import {cloneDeep} from "lodash";

import "./RoleCreationPage.component.scss";

const roleFormFields = _.memoize(({subsidiaries, disabled}): FormGridField[] => [
    {
        name: "roleName",
        fieldType: "input",
        fieldOptions: {
            id: "roleCreationName",
            placeholder: "Role Name",
            label: "Role Name",
            inputType: "text",
            disabled: disabled
        },
        validation: Yup.string()
            .trim()
            .required("Field is required.")
            .max(50, "Max. 50 characters."),
        columnClass: "col-12"
    },
    {
        name: "subsidiaries",
        fieldType: "select",
        fieldOptions: {
            id: "subsidiary",
            noValueLabel: "Choose subsidiaries...",
            label: "Permission for Subsidiaries",
            items: subsidiaries,
            multipleSelection: true,
            disabled: disabled
        },
        validation: Yup.string().nullable().required("Field is required."),
        columnClass: "col-12"
    },
]);

export interface RoleManagementPageProps {
    apiRoutes: Route[];
    drawerValues: any;
    createRole: any;
    editRole: any;
    subsidiariesLoading: boolean;
    subsidiariesList: any;
}

export type PermissionSection = {
    id?: number;
    section: string;
    open?: boolean;
    actions: {
        id?: number;
        name: string;
        routes: string[];
        open?: boolean;
    }[];
};

export interface RoleManagementPageState {
    roleName: string | null;
    editingId: any;
    formValid: boolean;
    roleAction: string;
    permissions: PermissionSection[];
    subsidiaries: any;
}

class RoleManagementPage extends Component<
    RoleManagementPageProps,
    RoleManagementPageState
> {
    constructor(props) {
        super(props);
        let previousRoutes = []

        if(props.drawerValues.role_obj &&
            props.drawerValues.role_obj.access)
            props.drawerValues.role_obj.access.map(access =>{
                previousRoutes.push({
                    "id": access.id,
                    "access": Object.keys(access.access).map(acc => {
                        if(access.access[acc].allow) return access.access[acc].val
                    }).filter(acc => acc),
                    "name": access.name
                })
            })

        this.state = {
            formValid: false,
            roleName: this.props.drawerValues.role_obj.name,
            editingId: props.drawerValues.role_obj.in.map(i => i.id),
            roleAction: this.props.drawerValues.role_action,
            subsidiaries: this.props.drawerValues.role_obj.subsidiaries,
            permissions: _.cloneDeep(permissionsJson).map((section, index) => {
                section.open = false;
                section.id = index;
                section.actions.map((action, key) => {
                    action.id = key;
                    let open = true
                    action.routes.map(r => {
                        let route = previousRoutes.find(previous => r.id === previous.id && r.name === previous.name)
                        if(route){
                            if(!r.access.every(acc => route.access.includes(acc))) open = false
                        } else open = false
                    })
                    action.open = open
                });
                return section;
            })
        };




        /*
        let activeRoutes = [
            {
                "id": 55,
                "access": [
                    "0b1"
                ],
                "name": "server_license_state"
            },
            {
                "id": 44,
                "access": [
                    "0b1"
                ],
                "name": "system_server_version"
            },
            {
                "id": 55,
                "name": "server_license_state",
                "access": [
                     "3"
                ]
            },
            {
                "id": 51,
                "access": [
                    "0b1", "555"
                ],
                "name": "configuration"
            },
            {
                "id": 55,
                "name": "server_license_state",
                "access": [
                     "2"
                ]
            },
            {
                "id": 51,
                "access": [
                    "555"
                ],
                "name": "configuration"
            },
            {
                "id": 444,
                "access": [
                    "0b1"
                ],
                "name": "system_server_version"
            },
            {
                "id": 55,
                "name": "server_license_state",
                "access": [
                     "3"
                ]
            }
        ];

        const uniq_1 = activeRoutes.filter((obj, index) => {
          return index === activeRoutes.findIndex(o =>
              obj.id === o.id &&
              obj.name === o.name &&
              _.difference(obj.access, o.access).length===0);
        });



        let concatActiveRoutes = cloneDeep(uniq_1);

        uniq_1.filter((obj, index) => {
            let find_index = uniq_1.findIndex(o => obj.id === o.id && obj.name === o.name)
            if(index !== find_index){
                concatActiveRoutes[find_index].access = _.uniq(concatActiveRoutes[find_index].access.concat(obj.access));
                delete concatActiveRoutes[index];
            }
        });


        concatActiveRoutes=concatActiveRoutes.filter(n => n);

        console.log('uniq_1', uniq_1)
        console.log('concatActiveRoutes', concatActiveRoutes)
        console.log('activeRoutes', activeRoutes)
        */

    }

    static getDerivedStateFromProps(props, state) {
        if (state.editingId && JSON.stringify(props.drawerValues.role_obj.in.map(i => i.id).sort()) !== JSON.stringify(state.editingId.sort()) ||
            state.roleAction !== props.drawerValues.role_action
        ) {
            let previousRoutes = []

            if(props.drawerValues.role_obj &&
                props.drawerValues.role_obj.access)
                props.drawerValues.role_obj.access.map(access =>{
                    previousRoutes.push({
                        "id": access.id,
                        "access": Object.keys(access.access).map(acc => {
                            if(access.access[acc].allow) return access.access[acc].val
                        }).filter(acc => acc),
                        "name": access.name
                    })
                })


            return {
                ...state,
                editingId: props.drawerValues.role_obj.in.map(i => i.id),
                roleName: props.drawerValues.role_obj.name,
                roleAction: props.drawerValues.role_action,
                subsidiaries: props.drawerValues.role_obj.subsidiaries,
                permissions: _.cloneDeep(permissionsJson).map(
                    (section, index) => {
                        section.open = false;
                        section.id = index;
                        section.actions.map((action, key) => {
                            action.id = key;
                            let open = true
                            action.routes.map(r => {
                                let route = previousRoutes.find(previous => r.id === previous.id && r.name === previous.name)
                                if(route){
                                    if(!r.access.every(acc => route.access.includes(acc))) open = false
                                } else open = false
                            })
                            action.open = open
                        });
                        return section;
                    }
                )
            };
        }

        return null;
    }

    checkIfAnyRouteSelected = () => {
        let selectedRoutes = false;
        this.state.permissions.map(section => {
            section.actions.map(action => {
                selectedRoutes = action.open == true ? true : selectedRoutes;
            });
        });

        return selectedRoutes;
    };

    handleSwitch = sectionId => {
        const oldPermissions = [...this.state.permissions];
        const sectionIndex = oldPermissions.findIndex(
            permission => permission.id == sectionId
        );
        if (sectionIndex > -1) {
            const actionIndex = oldPermissions[sectionIndex].actions.findIndex(
                action => action.open == true
            );

            if (actionIndex > -1) {
                // Remove All
                oldPermissions[sectionIndex].actions.map(action => {
                    action.open = false;
                    this.removePermissionsLink(action['key']);
                    return action;
                });
            } else {
                // Add All
                oldPermissions[sectionIndex].actions.map(action => {
                    action.open = true;
                    this.permissionsLink(sectionIndex, action['id']);
                    return action;
                });
            }
        }

        this.setState({ permissions: oldPermissions });
    };

    handleCheck = (sectionId, actionId) => {
        const oldPermissions = [...this.state.permissions];
        const sectionIndex = oldPermissions.findIndex(
            permission => permission.id == sectionId
        );
        if (sectionIndex > -1) {
            const actionIndex = oldPermissions[sectionIndex].actions.findIndex(
                action => action.id == actionId
            );

            if (actionIndex > -1) {
                oldPermissions[sectionIndex].actions[actionIndex].open =
                    !oldPermissions[sectionIndex].actions[actionIndex].open;
                if(oldPermissions[sectionIndex].actions[actionIndex].open) this.permissionsLink(sectionIndex, actionIndex);
                else this.removePermissionsLink(oldPermissions[sectionIndex].actions[actionIndex]['key']);
            }
        }

        this.setState({ permissions: oldPermissions });
    };

    permissionsLink = (sectionIndex, actionIndex) => {
        const oldPermissions = [...this.state.permissions];
        if (oldPermissions[sectionIndex].actions[actionIndex].open) {
                    oldPermissions.map(p => {
                        p.actions.map(a => {
                            if (oldPermissions[sectionIndex].actions[actionIndex]['link'].includes(a['key'])) {
                                a['open'] = true;
                                this.permissionsLink(p.id, a.id);
                            }
                        })
                    })
                }
    }

    removePermissionsLink = (actionKey) => {
        const oldPermissions = [...this.state.permissions];
        oldPermissions.map(p => {
            p.actions.map(a => {
                if(a['link'].includes(actionKey)){
                    a.open = false;
                    this.removePermissionsLink(a['key']);
                }
            })
        })
    }

    onFormChange = e => {
        this.setState({
            formValid: e.isValid,
            roleName: e.values["roleName"],
            subsidiaries: e.values["subsidiaries"]
        });
    };

    getActiveRoutes = () => {
        let activeRoutes = [];
        this.state.permissions.map(section =>
            section.actions.map(action => {
                if (action.open) {
                    activeRoutes = activeRoutes.concat(action.routes);
                }
            })
        );

        const uniqActiveRoutes = activeRoutes.filter((obj, index) => {
          return index === activeRoutes.findIndex(o =>
              obj.id === o.id &&
              obj.name === o.name &&
              _.difference(obj.access, o.access).length===0);
        });

        let concatActiveRoutes = cloneDeep(uniqActiveRoutes);

        uniqActiveRoutes.filter((obj, index) => {
            let find_index = uniqActiveRoutes.findIndex(o => obj.id === o.id && obj.name === o.name)
            if(index !== find_index){
                concatActiveRoutes[find_index].access = _.uniq(concatActiveRoutes[find_index].access.concat(obj.access));
                delete concatActiveRoutes[index];
            }
        });
        concatActiveRoutes=concatActiveRoutes.filter(n => n);

        return concatActiveRoutes;
    };

    onFormSubmit = () => {
        let roleInfo = {};
        let activeRoutes = this.getActiveRoutes();
        roleInfo["name"] = this.state.roleName;
        roleInfo["accesses"] = JSON.stringify(activeRoutes);
        roleInfo["editable"] = true;

        if (this.state.roleAction === ROLE_ACTIONS.ADD_ROLE) {
            roleInfo["subsidiary"] = this.state.subsidiaries.toString();
            this.props.createRole(roleInfo);
        } else if (this.state.roleAction === ROLE_ACTIONS.EDIT_ROLE) {
            this.state.subsidiaries.map(sub =>{
                let subsidiary = this.props.drawerValues.role_obj.in.find(i=>i.subsidiary === sub)
                if(subsidiary){
                    this.props.editRole(subsidiary.id, roleInfo);
                } else {
                    roleInfo["subsidiary"] = sub.toString();
                    this.props.createRole(roleInfo);
                }
            })
        }
    };

    toggleCollapse = collapseId => {
        const oldPermissions = [...this.state.permissions];
        const permissionIndex = oldPermissions.findIndex(
            permission => permission.id == collapseId
        );
        if (permissionIndex > -1) {
            oldPermissions[permissionIndex].open =
                !oldPermissions[permissionIndex].open;
        }

        this.setState({ permissions: oldPermissions });
    };

    renderHeader = (permissionSection) => {
        let anyFromList = false;
        let allFromList = true;

        permissionSection.actions.map(action => {
            if (action.open) {
                anyFromList = true;
            } else {
                allFromList = false;
            }
        });

        return (
            <React.Fragment>
                <div
                    className={`collapse-trigger ${
                        permissionSection.open && "show"
                    }`}
                    onClick={() => this.toggleCollapse(permissionSection.id)}
                >
                    <div className="collapse-header-span">
                        <span>{permissionSection.section}</span>
                    </div>
                </div>
                <Components.Switch
                    onClick={() => this.handleSwitch(permissionSection.id)}
                    on={anyFromList || allFromList}
                    enabled = {this.state.roleAction !== ROLE_ACTIONS.DETAILS_ROLE}
                    className={`${
                        anyFromList && !allFromList ? "semi-selected" : ""
                    }`}
                />
            </React.Fragment>
        );
    };

    render() {
        let form = roleFormFields({
            subsidiaries: SubsidiaryUtils.subsidiarySelectItems(
                this.props.subsidiariesList
            ),
            disabled: this.state.roleAction === ROLE_ACTIONS.DETAILS_ROLE
        });

        return (
            <div id="create-role">
                <div className="create-content">
                    <div>
                        <div className="form-spacer" />
                        <Form
                            key={this.state.editingId}
                            fields={form}
                            initialValues={this.state}
                            onChange={this.onFormChange}
                        />
                        <div className="form-spacer" />
                        <div className="row">
                            <div className="col-12">
                                {this.state.permissions.map(
                                    (permissionSection, key) => {
                                        return (
                                            <Collapse
                                                key={key}
                                                collapse_id={
                                                    permissionSection.section
                                                }
                                                open={permissionSection.open}
                                                header={this.renderHeader(
                                                    permissionSection
                                                )}
                                                toggleCollapse={
                                                    this.toggleCollapse
                                                }
                                            >
                                                {permissionSection.actions.map(
                                                    (action, key) => {
                                                        return (
                                                            <React.Fragment
                                                                key={`${action.name}_${key}`}
                                                            >
                                                                <div className="collapse_content">
                                                                    <span>
                                                                        {
                                                                            action.name
                                                                        }
                                                                    </span>

                                                                    {this.state.roleAction !== ROLE_ACTIONS.DETAILS_ROLE ?
                                                                        (
                                                                            <Components.Checkbox
                                                                                onChange={() =>
                                                                                    this.handleCheck(
                                                                                        permissionSection.id,
                                                                                        action.id
                                                                                    )
                                                                                }
                                                                                checked={
                                                                                    action.open
                                                                                }
                                                                                triggerChange={
                                                                                    false
                                                                                }
                                                                            />
                                                                        ) :
                                                                        (   <React.Fragment>
                                                                            { action.open ?
                                                                                (
                                                                                    <div className="checkbox-container">
                                                                                        <div className="checkbox checkbox-checked">
                                                                                        <i className="material-icons check-mark">check</i>
                                                                                        </div>
                                                                                        <span className="checkbox-label"></span>
                                                                                    </div>
                                                                                ) :
                                                                                (
                                                                                    <div className="checkbox-container">
                                                                                        <div className="checkbox checkbox-unchecked"></div>
                                                                                        <span className="checkbox-label"></span>
                                                                                    </div>
                                                                                )
                                                                            }
                                                                            </React.Fragment>
                                                                        )}
                                                                </div>
                                                            </React.Fragment>
                                                        );
                                                    }
                                                )}
                                            </Collapse>
                                        );
                                    }
                                )}
                                {!this.checkIfAnyRouteSelected() && (
                                    <div className="input-error">
                                        <span className="input-error-message">
                                            No permissions selected for this
                                            role.
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="form-spacer" />
                        {this.state.roleAction !== ROLE_ACTIONS.DETAILS_ROLE &&
                        (<div className="row">
                            <div className="col-12">
                                <button
                                    className="red-btn create-btn"
                                    onClick={this.onFormSubmit}
                                    disabled={
                                        !(
                                            this.state.formValid &&
                                            this.checkIfAnyRouteSelected()
                                        )
                                    }
                                >
                                    {this.props.drawerValues.form_button_name}
                                </button>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apiRoutes: skeletonStoreSelectors.apiRoutes(),
    subsidiariesList: authStoreSelectors.subsidiaries(state),
    subsidiariesLoading: authStoreSelectors.subsidiariesLoading(state)
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RoleManagementPage);
